import React, { useState } from 'react'
import MainLayout from '../../layouts/Main'

// import { useGetUserCampuses } from '../../../hooks/campuses';
import { useExportPageViewsReportForSchool, useGetPageViewsReportForSchool } from '../../../hooks/analytics';
import { useGetStudentOnboardingResponsesOptionsByField } from '../../../hooks/misc';

import BarChart from '../../sub_components/charts/BarChart';
import FilterTable from '../../sub_components/tables/FilterTable';
import ReportDatePicker from '../../sub_components/ReportDatePicker';

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/tables';
import { StudentOnboardingResponseOptionsField } from '../../../interfaces';

const PageViewsReport = () => {
    // let filterTableDataColumns__Campuses: IColumnProps[] = [
    //     { name: "ID", identifier: "id" },
    //     { name: "Campus", identifier: "name" },
    // ];
    let filterTableDataColumns__ProgramsOfStudy: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Program of Study", identifier: "name" },
    ];
    let filterTableDataColumns__PageViewsReport: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Full Name", identifier: "full_name" },
        { name: "Email", identifier: "email" },
        {
            name: "Group(s) with Views Count", identifier: "groups_data", render: (row: any, index: number) => {
                if (!row) return null;
                const rows = row.split(',');
                const groups = rows.map((row: any) => {
                    const [group, count] = row.split(' (');
                    return {
                        group: group,
                        count: count.replace(')', ''),
                    }
                });

                return <div className='immersion__table__cell__content__flex_rows'>
                    {groups.map((group: any, index: number) => {
                        return <div key={index} className='immersion__table__cell__content__flex_rows__item'>
                            <div className='immersion__table__cell__content__flex_rows__item__text'>{group.group}</div>
                            <div className='immersion__table__cell__content__flex_rows__item__text'>{group.count}</div>
                        </div>
                    })}
                </div>
            }
        },
    ];
    // let filterTableData__Campuses: IFilterableDataProps[] = [];
    let filterTableData__PageViewsReport: IFilterableDataProps[] = [];
    let filterTableData__ProgramsOfStudy: IFilterableDataProps[] = [];

    const [campusFilters, setCampusFilters] = useState<number[]>([]); // eslint-disable-line
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [programsOfStudyFilters, setProgramsOfStudyFilters] = useState<number[]>([]);

    const { data: programsOfStudy } = useGetStudentOnboardingResponsesOptionsByField(StudentOnboardingResponseOptionsField.PROGRAM_OF_STUDY);

    const programsOfStudyOptions = programsOfStudy?.map((program, index) => ({
        id: index,
        name: program,
    })) ?? [];

    const filterQuery = new URLSearchParams();
    filterQuery.set("start_date", startDate);
    filterQuery.set("end_date", endDate);
    campusFilters.forEach((id) => filterQuery.append("campus_ids", id.toString()));
    programsOfStudyFilters.forEach((id) => filterQuery.append("programs_of_study", programsOfStudyOptions[id].name));

    // const { data: campuses } = useGetUserCampuses();
    const { data: pageViewsReport } = useGetPageViewsReportForSchool(filterQuery.toString());

    const { mutate: exportCsv } = useExportPageViewsReportForSchool();
    // if (campuses) {
    //     filterTableData__Campuses = campuses.map((campus) => ({
    //         id: campus.id,
    //         name: campus.name,
    //     }));
    // }

    if (programsOfStudyOptions) {
        filterTableData__ProgramsOfStudy = programsOfStudyOptions.map((program) => ({
            id: program.id,
            name: program.name,
        }));
    }

    if (pageViewsReport) {
        filterTableData__PageViewsReport = pageViewsReport.table_data.map((user) => ({
            id: user.id,
            full_name: user.full_name,
            email: user.email,
            groups_data: user.groups_data.map((group) => group.group + ' (' + group.count + ')').join(','),
        }));
    }

    const onExportCsv = () => {
        exportCsv({ payload: { filterQuery: filterQuery.toString() } });
    }

    return (
        <MainLayout>
            <div className='immersion__careers_report'>
                <div className='immersion__careers_report__header'>
                    <div className='immersion__careers_report__header__content'>
                        <h2 className='immersion__careers_report__header__content__title'>Page Views Report</h2>
                        <p className='immersion__careers_report__header__content__description'>
                            This slide gives an overview of page views to the platform since the start of data collection (20/04/24).
                            The chart to the bottom left shows a cumulative timeline of page views to the platform.
                            The table to the bottom right shows the latest date a user has had activity on the platform.
                        </p>
                    </div>
                    <div className='immersion__careers_report__header__actions'>
                        <button className='immersion__btn immersion__btn__primary immersion__careers_report__header__actions__button' onClick={onExportCsv}>Export CSV</button>
                    </div>
                </div>
                <div className='immersion__careers_report__chart_body'>
                    <div className='immersion__careers_report__chart__row'>
                        {/* {campuses?.length ?
                            <FilterTable
                                columns={filterTableDataColumns__Campuses}
                                data={filterTableData__Campuses}
                                filters={campusFilters}
                                setFilters={setCampusFilters}
                                enableFilters={true}
                            />
                            : <div className='immersion__careers_report__chart__no_data'>
                                No campuses found
                            </div>
                        } */}
                        <FilterTable
                            columns={filterTableDataColumns__ProgramsOfStudy}
                            data={filterTableData__ProgramsOfStudy}
                            enableFilters={true}
                            filters={programsOfStudyFilters}
                            setFilters={setProgramsOfStudyFilters}
                        />
                        <ReportDatePicker
                            required={true}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                        />
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__PageViewsReport}
                            data={filterTableData__PageViewsReport}
                            filters={[]}
                            setFilters={() => { }}
                            enableFilters={false}
                        />
                        {pageViewsReport?.page_views_chart_data.length ? (
                            <BarChart
                                data={pageViewsReport?.page_views_chart_data ?? []}
                                width={400}
                                height={318}
                                xLabel=""
                                yLabel="Total Page Views"
                                xTickAngle={90}
                                xInterval={0}
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No analytics data available
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </MainLayout>
    );
};

export default PageViewsReport;